import * as yup from "yup";

export const loginValidationSchema = yup.object({
  email: yup.string().required("Email is required").email("Please enter a valid email"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      "Password at least 8 characters with uppercase, lowercase, numbers, and special characters",
    ),
});


export const signupValidationSchema = yup.object({
  firstName: yup
    .string()
    .required("First name is required.")
    .min(2, "First name must be at least 2 characters"),
  lastName: yup
    .string()
    .required("Last name is required.")
    .min(2, "Last name must be at least 2 characters"),
  email: yup.string().required("Email is required.").email("Please enter a valid email address."),
  password: yup
    .string()
    .required("Password is required.")
    .min(8, "Password must be at least 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      "Use at least 8 characters with uppercase, lowercase, numbers, and special characters",
    ),
  confirmPassword: yup
    .string()
    .required("Please confirm your password")
    .oneOf([yup.ref("password")], "Passwords must match"),
  phone: yup.string().nullable().notRequired(),
  address: yup.string().nullable().notRequired(),
  tosAccepted: yup
    .boolean()
    .required("You must agree to the Terms of Service and Privacy Policy.")
    .oneOf([true], "You must agree to the Terms of Service and Privacy Policy."),
  marketingOptIn: yup.boolean().default(false).optional(),
});
